module.exports = __webpack_public_path__ + "img/rwgj-icon.58f3e60.svg";